import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector      : 'app-register',
	templateUrl   : './register.component.html',
	encapsulation : ViewEncapsulation.None
})

export class RegisterComponent implements OnInit {
	@Input() registerData : any;
	public isMobile : boolean;

	constructor() {
		if ( devicePixelRatio > 1.5 && document.body.clientWidth < 767 )
            this.isMobile = true;
        else
            this.isMobile = false;
	}

	ngOnInit() {}
}